(() => {
  /*============================================================================
   Blog Post Carousel custom functions
  ==============================================================================*/

  function updateCarousel() {
    const itemWidth = domItems.carouselItems[0].offsetWidth;
    domItems.carousel.style.transform = `translateX(${
      -currentIndex * itemWidth
    }px)`;
    updatePagination();

    domItems?.stars?.forEach((star) => {
      star.style.width = "";
      star.style.height = "";
    });
  }

  function updatePagination() {
    domItems.pagination.innerHTML = "";
    for (let i = 0; i < domItems.carouselItems.length; i++) {
      const dot = document.createElement("span");
      dot.classList.add("carousel-dot");
      if (i === currentIndex) {
        dot.classList.add("active");
      }
      dot.addEventListener("click", () => {
        currentIndex = i;
        updateCarousel();
      });
      domItems.pagination.appendChild(dot);
    }
  }

  /**
   * Event listeners on mini cart DOM items.
   *
   * @param none
   */

  const eventListeners = () => {
    const handleNavigation = (direction) => {
      currentIndex =
        (currentIndex + direction + domItems.carouselItems.length) %
        domItems.carouselItems.length;
      updateCarousel();
    };

    domItems.prevButton.addEventListener("click", () => handleNavigation(-1));
    domItems.nextButton.addEventListener("click", () => handleNavigation(1));

    window.addEventListener("resize", updateCarousel);
  };

  /**
   * Load event on blog post carousel.
   *
   * @param none
   */

  let domItems = {};
  let currentIndex = 0;

  const onLoad = async () => {
    domItems = {
      carousel: document.querySelector(".blog-post-product-carousel .carousel"),
      carouselItems: document.querySelectorAll(
        ".blog-post-product-carousel .carousel-item"
      ),
      nextButton: document.querySelector(
        ".blog-post-product-carousel .carousel-next"
      ),
      prevButton: document.querySelector(
        ".blog-post-product-carousel .carousel-prev"
      ),
      pagination: document.querySelector(
        ".blog-post-product-carousel .carousel-pagination"
      ),
      stars: document.querySelectorAll(
        ".blog-post-product-carousel .bv_stars_button_container svg"
      ),
    };

    eventListeners();
    updateCarousel();
  };

  if (document.readyState === "complete") {
    onLoad();
  } else {
    window.addEventListener("load", onLoad);
  }
})();
